import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import FooterSection from './FooterSection';
import '../styles/Footer.css';
import { FaFacebookF, FaInstagram, FaLinkedinIn } from 'react-icons/fa';

function Footer() {
  // 🔄 Charge la langue actuelle
  const [lang, setLang] = useState(localStorage.getItem("lang") || "fr");

  // 🔄 Écoute changement depuis la NavBar
  useEffect(() => {
    const updateLang = () => setLang(localStorage.getItem("lang") || "fr");
    window.addEventListener("langChanged", updateLang);
    return () => window.removeEventListener("langChanged", updateLang);
  }, []);

  // 📌 TEXTES TRADUITS
  const t = {
    // Titres
    market: lang === "fr" ? "TSENAN’NY TANTSAHA" : "TSENAN’NY TANTSAHA",
    account: lang === "fr" ? "MON COMPTE" : "NY KAONTIKO",
    service: lang === "fr" ? "SERVICE CLIENT" : "SERVISY HO AN'NY MPANJIFA",
    social: lang === "fr" ? "RÉSEAUX SOCIAUX" : "TAMBAJOTRA SOSIALY",

    // Col. 1
    livraison: lang === "fr" ? "Livraison" : "Fandefasana entana",
    confidentialite: lang === "fr" ? "Politique de confidentialité" : "Politika fiarovana angon-drakitra",
    cgv: lang === "fr" ? "CGV" : "Fepetra sy fombafomba",

    // Col. 2
    commandes: lang === "fr" ? "Mes commandes" : "Ny entana nafarako",
    favoris: lang === "fr" ? "Mes favoris" : "Ny vokatra tiako indrindra",
    connect: lang === "fr" ? "Se connecter" : "Hiditra ao amin'ny kaonty",
  };

  return (
    <footer className="footer">
      <div className="footer-columns">

        {/* === MARKET === */}
        <FooterSection title={t.market}>
          <li><Link to="/livraison">{t.livraison}</Link></li>
          <li><Link to="/confidentialite">{t.confidentialite}</Link></li>
          <li><Link to="/cgv">{t.cgv}</Link></li>
        </FooterSection>

        {/* === MON COMPTE === */}
        <FooterSection title={t.account}>
          <li><Link to="/mes-commandes">{t.commandes}</Link></li>
          <li><Link to="/favoris">{t.favoris}</Link></li>
          <li><Link to="/information?simple=1">{t.connect}</Link></li>
        </FooterSection>

        {/* === SERVICE CLIENT === */}
        <FooterSection title={t.service}>
          <li>034 69 402 91</li>
          <li>034 67 101 37</li>
          <li>
            <a href="mailto:contact@tsenannytantsaha.mg">
              contact@tsenannytantsaha.mg
            </a>
          </li>
        </FooterSection>

        {/* === RESEAUX SOCIAUX === */}
        <FooterSection title={t.social}>
          <div className="social-icons">
            <a href="https://facebook.com" target="_blank" rel="noreferrer"><FaFacebookF /></a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer"><FaInstagram /></a>
            <a href="https://linkedin.com" target="_blank" rel="noreferrer"><FaLinkedinIn /></a>
          </div>
        </FooterSection>

      </div>
    </footer>
  );
}

export default Footer;
